import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DonutChart = ({ isGold, result }) => {
  const investAmt = Number(result.investAmt);
  const estReturn = Number(result.estReturn);
  const total = investAmt + estReturn;

  const data = {
    labels: ["Savings", "Est. returns"],
    datasets: [
      {
        label: isGold ? "Gold" : "Silver",
        data:
          total > 0
            ? [
                ((investAmt / total) * 100).toFixed(2),
                ((estReturn / total) * 100).toFixed(2),
              ]
            : [0, 0],
        backgroundColor: isGold
          ? ["#ffe484", "#FFD238"]
          : ["#D4D4D4", "#BFBFBF"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "30%",
    responsive: true,
    maintainAspectRatio: false,
    // Set higher device pixel ratio for better quality
    devicePixelRatio: 3, // or 3 for even sharper rendering
    layout: {
      padding: {
        top: 20,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#323232",
          font: {
            size: 12,
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif", // explicit font
          },
          boxWidth: 10,
          boxHeight: 10,
          padding: 20,
          usePointStyle: true, // better rendering for legend items
        },
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
          family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        },
        backgroundColor: "#fff",
        borderWidth: 1,
        borderRadius: 4,
        padding: 6,
        formatter: (value) => `${value}%`,
        anchor: "end",
        align: "center",
        clamp: true,
        clip: false,
        display: true,
        offset: 20,
      },
      // Disable animations when zoomed for better performance
      zoom: {
        pan: {
          enabled: true,
          mode: 'xy',
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true
          },
          mode: 'xy',
          onZoomComplete: ({ chart }) => {
            // Disable animations after zoom
            chart.options.animation = false;
            chart.update();
          }
        }
      }
    },
    // Improve rendering quality
    elements: {
      arc: {
        borderWidth: 0,
        borderJoinStyle: 'round',
      }
    },
    animation: {
      animateScale: false,
      animateRotate: false
    }
  };

  return (
    <div
      style={{
        width: "200px",
        height: "200px",
        margin: "auto",
        // Add CSS transform for better rendering
        transform: 'translateZ(0)',
      }}
    >
      <Doughnut 
        data={data} 
        options={options} 
        // Force redraw when props change
        redraw={true}
      />
    </div>
  );
};

export default DonutChart;